<template>
  <div>
    <custom-callout
      :border-color="statusColor"
      class-main="mt-3 rounded"
      :has-toggle="false"
    >
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col-12 col-md-2" :class="!isMobile ? 'text-center' : ''">
          <div class="d-flex flex-column color-black mr-2">
            <div v-if="isMobile" class="row">
              <div class="col-10">
                <span
                  :class="
                    `badge badge-pill w-2 font-weight-bold p-2 badge-${statusColor}`
                  "
                />
                <span class="ml-1 font-16">
                  {{ data.billingStatusName | empty }}
                </span>
              </div>
              <div v-if="visibleProcessCheck" class="col-2">
                <check-box
                  v-model="data.selected"
                  class="
                    checkbox
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                />
              </div>
            </div>
            <div v-else class="row">
              <div
                :class="
                  `col-12 mb-1 badge-pill font-weight-bold font-16 p-2 w-min-80 mx-auto badge-${statusColor}`
                "
              >
                {{ data.billingStatusName | empty }}
              </div>
              <div class="col-12 font-14 font-weight-bold mt-2">
                {{ data.billNumber | empty }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 border-left">
          <div class="row mb-3">
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block border-mobile">Periodo:</span>
              <span class="font-16 color-black">
                {{ data.period | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Monto:</span>
              <span class="font-16 color-black">
                {{ data.totalBillAmount | price }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Fecha de Estatus:</span>
              <span class="font-16 color-black">
                {{ data.billingStatusDate | date('DD/MM/YYYY') }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Intervenido por:</span>
              <span class="font-16 color-black">
                {{ data.interventionUserFullName | empty }}
              </span>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Proveedor:</span>
              <span class="font-16 color-black">
                {{ data.companyName | empty }}
              </span>
            </div>
            <div
              v-if="canPreliminaryInvoiceCount | isPreliminar"
              class="col-12 col-md-3 my-2"
            >
              <span class="data-title d-block">Días sin Someter Factura:</span>
              <span class="font-16 color-black">
                <span
                  :class="`mb-1 badge badge-pill font-14 pt-2 pb-2 mx-auto`"
                  :style="
                    `background-color: ${countdaysAscendantBgColor(
                      data.daysWithoutSubmitting
                    )}; color: ${countdaysAscendantColor(
                      data.daysWithoutSubmitting
                    )}`
                  "
                >
                  {{ data.daysWithoutSubmitting ?? 0 }}
                </span>
              </span>
            </div>

            <div v-if="showRevisionDays" class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Días en Revisión:</span>
              <span class="font-16 color-black">
                <span
                  :class="`mb-1 badge badge-pill font-14 pt-2 pb-2 mx-auto`"
                  :style="
                    `background-color: ${countdaysAscendantBgColor(
                      data.revisionDays
                    )}; color: ${countdaysAscendantColor(data.revisionDays)}`
                  "
                >
                  {{ data.revisionDays ?? 0 }}
                </span>
              </span>
            </div>

            <div
              v-if="canReceivedDate && !isPreliminar"
              class="col-12 col-md-3 my-2"
            >
              <span class="data-title d-block">Días de Cumplimiento:</span>
              <span class="font-16 color-black">
                <span
                  :class="`mb-1 badge badge-pill font-14 pt-2 pb-2 mx-auto`"
                  :style="
                    `background-color: ${countDaysDescendingBgColor(
                      data.countDays
                    )}; color: ${countDaysDescendingColor(data.countDays)}`
                  "
                >
                  {{ data.countDays | empty }}
                </span>
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Fecha y Hora de Sometido:</span>
              <span class="font-16 color-black">
                {{ submitDate | date('DD/MMM/YYYY - hh:mm A') }}
              </span>
            </div>
            <div
              v-if="canComplianceDate && !isPreliminar"
              class="col-12 col-md-3 my-2"
            >
              <span class="data-title d-block">
                Fecha de Recibo de Factura por la USPQRP:
              </span>
              <span class="font-16 color-black">
                {{ data.arriveDate | date('DD/MMM/YYYY - hh:mm A') }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="col col-md-2 col-12"
          :class="!isMobile ? 'd-flex justify-content-end p-0' : 'mt-2'"
        >
          <drop-down class="mr-3 align-vertical-center" :items="actionItems" />

          <div
            v-if="!isMobile && visibleProcessCheck"
            class="check-box-border-left d-flex"
          >
            <check-box v-model="data.selected" class="ml-3 checkbox" text="" />
          </div>
        </div>
      </div>
      <div v-if="showBillCancel" class="row">
        <div class="col-md-9 col-sm-12">
          <div class="gray-6 font-14 mb-2">
            Comentario:
          </div>
          <validation-observer ref="biilCancelform" novalidate tag="form">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="billCancelComment"
                custom-error-msg="Favor de entrar un comentario."
                :error="errors[0]"
              />
            </validation-provider>
          </validation-observer>
        </div>
        <div class="col-md-3 text-right mt-4">
          <action-button
            class="w-45"
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
            @click="showBillCancel = false"
          >
            Cancelar
          </action-button>
          <action-button
            i="fas fa-arrow-circle-right"
            variant="success pl-4 pr-4"
            @click="cancelBill()"
          >
            Cambiar
          </action-button>
        </div>
      </div>
    </custom-callout>
    <div
      v-if="data.days !== null && data.days !== undefined && data.days > 0"
      class="container-exception"
    >
      <div class="row ml-2">
        <div class="col-md-3 d-flex">
          <span
            class="
              bell
              orange-icon-badge-align
              fa fa-bell-exclamation
              mr-3
              mt-3
            "
          />
          <p class="font-14 color-exception mt-3">
            Información de la Excepción Asignada.
          </p>
        </div>
        <div class="col-md-3 d-flex align-items-center">
          <strong class="font-14 color-black">Días Disponibles:</strong>

          <div class="container-day ml-2">
            <p class="d-flex justify-content-center orange">{{ data.days }}</p>
          </div>
        </div>
        <div class="col-md-3 d-flex align-items-center">
          <strong class="font-14">Fecha Limite:</strong>
          <p class="font-14 mt-3 ml-2">{{ data.dateLimit | date }}</p>
        </div>
        <div class="col-md-3 d-flex align-items-center">
          <strong class="font-14">Comentario:</strong>

          <p class="font-14 mt-3 ml-2">{{ data.comment }}</p>
        </div>
      </div>
    </div>
    <div v-if="showPanel" class="panel-wrap pt-2 pb-2 mt-2">
      <div class="panel-assign ml-3 mr-3 mt-3 mb-3">
        <br />
        <div class="pl-4 mb-2">
          <span
            class="orange-icon orange-icon-badge-align fa fa-ballot-check"
          />
          <strong class="py-2 pl-2 font-16 color-assign">
            Asignar Excepción
          </strong>
        </div>
        <validation-observer ref="assignRef" v-slot="{}" tag="form">
          <div class="row pl-4 pr-3">
            <div class="col-md-4">
              <span class="data-title d-block mb-2">
                Seleccione días permitidos para facturar:
              </span>
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  greaterThanZero: 'Los días permitidos deben ser mayor que 0.',
                  required: 'Los días permitidos para facturar son requeridos.',
                }"
                rules="required|greaterThanZero"
              >
                <custom-input
                  v-model="inputDayQty"
                  :error="errors[0]"
                  maxlength="2"
                  :min="0"
                  show-char-count
                  type="number"
                />
              </validation-provider>
            </div>
            <div class="col-md-3">
              <span class="data-title d-block mb-2">
                Fecha límite para someter factura:
              </span>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-date-picker
                  v-model="daysFromInput"
                  :class-container="'w-100'"
                  custom-error-msg="La fecha es requerida."
                  :error="errors[0]"
                  format="dd/MMM./yyyy"
                  :min-date="currentDate"
                />
              </validation-provider>
            </div>
          </div>
          <div class="row pl-4 mt-3 pr-4">
            <div class="col-md-12">
              <span class="data-title d-block mb-2">
                Razón de asignación de excepción:
              </span>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-text-area
                  v-model="reason"
                  :count-classes="['float-right']"
                  custom-error-msg="La razón es requerida."
                  :error="errors[0]"
                  :maxlength="500"
                  show-char-count
                />
              </validation-provider>
            </div>
            <div class="col-md-12">
              <action-button
                class="float-right ml-2"
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success mt-3"
                @click="saveAssign()"
              />
              <action-button
                class="float-right"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger mb-4 mt-3"
                @click="cancel()"
              />
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
    <div
      v-if="data.billingStatusId == 7 && canShowSifdeMessage"
      class="container-exception"
    >
      <div class="row ml-2">
        <div class="col-md-12 d-flex">
          <span
            class="
              bell
              orange-icon-badge-align
              fa fa-bell-exclamation
              mr-3
              mt-3
            "
          />
          <p class="font-14 color-exception mt-3">
            {{ data.responseSifdeLog }}
          </p>
        </div>
      </div>
    </div>
    <error
      v-if="data.failedDeliveryAttempt"
      class="mt-2"
      is-alert-mode
      :message="failedDeliveryMessage"
    />
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import utilities from '@/utils/utilities.js';
import DropDown from 'dropdown';
import CheckBox from 'CheckBox';
import store, { modulesName } from '@/store/index';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';
import Error from 'custom-error';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import billingStatus from '@/utils/constants/billingStatus';
import {
  getDays,
  submitException,
  updateBillingStatus,
} from '@/services/provider/billing-history.api';
export default {
  name: 'BillResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    DropDown,
    CheckBox,
    CustomTextArea,
    CustomDatePicker,
    CustomInput,
    ActionButton,
    Error,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    visibleProcessCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      datos: this.data,
      isEdit: false,
      showPanel: false,
      selectedDay: null,
      inputDayQty: null,
      datePkr: null,
      exceptionLimitDate: null,
      reason: null,
      limitDays: null,
      limitDaysFromDb: [
        {
          id: 1,
          name: 61,
          value: false,
        },
      ],
      showBillCancel: false,
      billCancelComment: null,
    };
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      if (
        this.data.days !== null &&
        this.data.days !== undefined &&
        this.data.days > 0
      ) {
        this.reason = this.data.comment;
        this.daysFromInput = this.data.dateLimit;
        this.inputDayQty = this.data.days;
      }

      this.addDays(new Date(), 1);
    },
    addDays(days) {
      var result = new Date();
      if (!days) {
        result = null;
      } else {
        result.setDate(result.getDate() + parseInt(days));
      }

      return result;
    },
    substractDay(date) {
      let inputDate = new Date(date);
      inputDate.setHours(0, 0, 0, 0);
      let now = new Date();
      now.setHours(0, 0, 0, 0);
      var difference = inputDate.getTime() - now.getTime();
      this.inputDayQty = parseInt(difference / (1000 * 60 * 60 * 24));
      return difference;
    },
    getValueSelected(data, idx) {
      this.selectedDay = data.name;
      this.$set(this.limitDaysFromDb[idx], 'value', true);
    },
    cancel() {
      this.showPanel = false;
      if (!this.isEdit) {
        this.daysFromInput = null;
        this.reason = null;
        this.inputDayQty = null;
      } else {
        this.reason = this.data.comment;
        this.daysFromInput = this.data.dateLimit;
        this.inputDayQty = this.data.days;
      }
      this.setData();
      this.$emit('on-reload');
    },
    async saveAssign() {
      const isValid = await this.$refs.assignRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      } else {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          this.isEdit
            ? `¿Está seguro(a) que desea editar la excepción para la factura <strong>${this.data.billNumber}</strong>? `
            : `¿Está seguro(a) que desea asignar la excepción para la factura <strong>${this.data.billNumber}</strong>? `,
          'Sí',
          'No'
        );
        if (answer) {
          let dataToSave = {
            billId: this.data.billId,
            exceptionLimitDate: this.daysFromInput,
            reason: this.reason,
            limitDays: parseInt(this.inputDayQty),
          };
          await submitException(dataToSave).then(() => {
            this.ShowToast(
              'Proceso Exitoso.',
              this.isEdit
                ? 'La excepción ha sido actualizada exitosamente.'
                : 'La excepción ha sido asignada exitosamente.',
              'success'
            );
          });
          this.showPanel = false;
          this.cancel();
        }
      }
    },
    async getDaysExeptions() {
      getDays().then((data) => {
        this.limitDaysFromDb = data.data;
      });
    },
    countDaysDescendingBgColor(count) {
      return !count
        ? ''
        : count < 10
        ? '#c9545e'
        : count < 20
        ? '#f8eb7f'
        : '#a4e5b3';
    },
    countDaysDescendingColor(count) {
      return !count ? '' : count < 10 ? 'white' : 'black';
    },
    countdaysAscendantBgColor(count) {
      return !count
        ? '#a4e5b3'
        : count < 10
        ? '#a4e5b3'
        : count < 20
        ? '#f8eb7f'
        : '#c9545e';
    },
    countdaysAscendantColor(count) {
      return !count ? '' : count > 10 ? 'white' : 'black';
    },
    async cancelBill() {
      const isValidForm = await this.$refs.biilCancelform.validate();
      if (!isValidForm) return;
      const {
        data: { isValid, message },
      } = await updateBillingStatus({
        billId: this.data.billId,
        newBillingStatus: billingStatus.Cancelada,
        comment: this.billCancelComment,
      });

      if (!isValid) {
        this.ShowToast('', message, 'error');
        return;
      }
      this.ShowToast(
        'Proceso Exitoso.',
        'El factura fue cancelada exitosamente.',
        'success'
      );
      this.showBillCancel = false;
      this.$emit('on-reload');
    },
  },
  computed: {
    isPreliminar() {
      return this.data.billingStatusId === billingStatus.Preliminar;
    },
    isPendingRevision() {
      return this.data.billingStatusId === billingStatus.PendienteRevision;
    },
    showRevisionDays() {
      return (
        this.userHasPermissions('rempro.invoice.Pending.Revision') &&
        !(
          this.data.billingStatusId === billingStatus.Preliminar ||
          this.data.billingStatusId === billingStatus.PendienteIntervencion ||
          this.data.billingStatusId === billingStatus.EnProcesoIntervencion
        )
      );
    },
    daysFromInput: {
      get: function() {
        return this.addDays(this.inputDayQty);
      },
      set: function(newValue) {
        this.substractDay(newValue);
        return newValue;
      },
    },
    currentDate() {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    failedDeliveryMessage() {
      const attemptDate = this.$options.filters.date(
        this.data.failedDeliveryAttemptDate,
        'DD/MMM/YYYY - hh:mm A'
      );
      return `Ocurrió un error en el último intento de enviar la factura al sistema Oracle ERP. (Fecha del Intento: ${attemptDate})`;
    },
    canShowSifdeMessage() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.vouchersifdemessage'
      );
    },
    actionItems() {
      const items = [];
      items.push({
        label: 'Entrar',
        icon: 'fas fa-file-import color-green',
        variant: 'outline-success m-2 px-4',
        click: () => this.$emit('on-view-bill'),
      });

      if (
        this.userHasPermissions(
          'rempro.providers.billinghistory.exceptionassignment'
        )
      ) {
        if (this.userHasPermissions('rempro.billing.assignException')) {
          if (!this.data.days && this.isPreliminar) {
            items.push({
              label: 'Asignar Excepción',
              icon: 'fas fa-solid fa-ballot-check color-green',
              variant: 'outline-success m-2 px-4',
              click: () => {
                (this.daysFromInput = null),
                  (this.reason = null),
                  (this.inputDayQty = null),
                  (this.isEdit = false),
                  (this.showPanel = true);
              },
            });
          }
        }

        if (
          this.data.days !== null &&
          this.data.days !== undefined &&
          this.data.days > 0 &&
          this.userHasPermissions('rempro.billing.editException')
        ) {
          items.push({
            label: 'Editar Excepción',
            icon: 'fas fa-solid fa-edit color-green',
            variant: 'outline-success m-2 px-4',
            click: () => {
              (this.reason = this.data.comment),
                (this.daysFromInput = this.data.dateLimit),
                (this.inputDayQty = this.data.days),
                (this.isEdit = true),
                (this.showPanel = true);
            },
          });
        }
      }

      if (this.canCancelBill) {
        items.push({
          label: 'Cancelar',
          icon: 'fas fa-times-circle color-red',
          variant: 'outline-danger m-2 px-4',
          click: () => {
            this.showBillCancel = true;
            this.billCancelComment = null;
          },
        });
      }
      return items;
    },
    statusColor() {
      return utilities.parseStateColorBillingByStatus(
        this.data.billingStatusId
      );
    },
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
    submitDate() {
      return this.data.billingStatusId !== billingStatus.Preliminar
        ? this.data.billSubmittedDate
        : null;
    },
    canReceivedDate() {
      return this.userHasPermissions('rempro.display.received.date');
    },
    canComplianceDate() {
      return this.userHasPermissions('rempro.compliance.date');
    },
    canPreliminaryInvoiceCount() {
      return this.userHasPermissions('rempro.Preliminary.Invoice.Count');
    },
    canCancelBill() {
      return (
        this.userHasPermissions('rempro.billing.cancel') &&
        this.data.billingStatusId == billingStatus.Preliminar
      );
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.border-radius--light {
  border-radius: 0px !important;
}

.badge-green-light-1 {
  background-color: map-get($colors, 'green-light-1');
}
.badge-violet {
  background-color: map-get($colors, 'violet');
}
.badge-yellow {
  background-color: map-get($colors, 'secondary-23');
}
.badge-brown {
  background-color: map-get($colors, 'brown');
}
.badge-orange-light {
  background-color: map-get($colors, 'orange-light');
}
.badge:empty {
  display: inline-block;
}
.badge-gray {
  background-color: map-get($colors, 'gray');
}

.align-vertical-center {
  margin-top: auto;
  margin-bottom: auto;
}
.panel-assign {
  background-color: white;
  border-radius: 5px;
}
.panel-wrap {
  background-color: #f7f7f7;
}
.check-box-border-left {
  height: 9rem;
  border-left: 1px solid #dee2e6 !important;
  > div {
    margin-top: auto;
    margin-bottom: auto;
  }
}

.w-min-80 {
  min-width: 80% !important;
}

@media only screen and (max-width: 768px) {
  .border-left {
    border-left: unset !important;
  }

  .border-mobile {
    border-top: 1px solid #dee2e6 !important;
    margin-top: 1rem;
  }
}
.orange-icon {
  color: #ff7058;
}
.color-assign {
  color: #405d61;
}
.container-exception {
  background-color: #fff5e8;
}
.bell {
  color: #af6708;
  font-size: 22px;
}
.color-exception {
  color: #af6708;
}
.container-day {
  border-style: solid;
  border-color: #ff5b5c;
  border-radius: 30px;
  width: 100px;
  height: 30px;
  background-color: #ffebeb;
}
.orange {
  color: #ff7058;
}
</style>
